import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export const HowItWorks = () => {
  const { t } = useLanguage();
  return (
    <section id="how" data-testid="how-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0055FF]">
            {t.how.kicker}
          </div>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold tracking-tight text-neutral-900">
            {t.how.title}
          </h2>
        </div>

        <div className="mt-12 md:mt-16 grid md:grid-cols-3 gap-6 md:gap-8 relative">
          {/* connecting line on desktop */}
          <div className="hidden md:block absolute top-16 left-[16.6%] right-[16.6%] h-[2px] bg-gradient-to-r from-[#0055FF]/20 via-[#FF7A00]/40 to-[#0055FF]/20" />

          {t.how.steps.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`how-step-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative rounded-3xl bg-white border border-slate-200 p-8 md:p-10 hover:shadow-xl transition-shadow"
            >
              <div className="relative z-10 w-14 h-14 rounded-2xl bg-neutral-900 text-white flex items-center justify-center font-heading font-bold text-lg">
                {s.n}
              </div>
              <h3 className="mt-6 font-heading text-2xl font-semibold text-neutral-900">{s.t}</h3>
              <p className="mt-3 text-neutral-600 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="mt-12 md:mt-16"
          data-testid="how-image-wrapper"
        >
          <img
            src="/images/fp-occ-firmenevents.webp"
            alt={t.how.imgAlt}
            loading="lazy"
            decoding="async"
            width={1400}
            height={1011}
            data-testid="how-image"
            className="w-full h-auto rounded-3xl md:rounded-[36px] border border-slate-200 shadow-xl shadow-neutral-900/5 object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
